<template>
  <div>
    <Transport :is-loading-arravals-data="isLoadingArravalsData" :layout-type="layoutType" />
    <div v-if="layoutType === 'traffic'">
      <Traffic />
    </div>
    <div v-if="layoutType === 'weather'">
      <Weather />
    </div>
  </div>
</template>

<script>
import Transport from './Components/Transport/Transport'
import Weather from './Components/Weather/Weather'
import Traffic from './Components/Traffic/Traffic'
export default {
  name: 'Layouts',
  components: {
    Transport,
    Weather,
    Traffic,
  },
  props: {
    layoutType: String,
    isLoadingArravalsData: Boolean,
  },
}
</script>

<style src="./styles.css"></style>
